module.exports = __webpack_public_path__ + "92ba1dfda8b64cee678fa27ca8abd3ba.svg";